import { clientInsightService } from 'config/api';
import actionTypes from './actionTypes';

export const getClientInsights =
  ({ profileIds = [], apiVersion = 'v2' }) =>
  async (dispatch) => {
    dispatch({
      type: actionTypes.CLIENT_INSIGHTS_LOADING,
    });

    try {
      const url = `/${apiVersion}/PurchaseInsightMetrics`;
      const { data } = await clientInsightService.post(url, { profileIds });

      dispatch({
        type: actionTypes.CLIENT_INSIGHTS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: actionTypes.CLIENT_INSIGHTS_ERROR,
        payload: error,
      });
    }
  };

export const clearClientInsights = () => {
  return {
    type: actionTypes.CLIENT_INSIGHTS_CLEAR,
  };
};
